export const sidebarConstants = {
  SIDEBAR_SET: 'set'
}
